import React from 'react';
import { ExperienceSuccessTracker as ViewExperienceSuccessTracker } from '@atlassian/jira-common-experience-tracking-viewing/src/view/experience-tracker-consumer/result-declared/index.tsx';
import { AsyncNoSoftwareLicense } from '@atlassian/jira-spa-apps-common/src/error-screens/no-software-license/async.tsx';

export const NoSoftwareLicense = () => (
	<ViewExperienceSuccessTracker location="ng-board-context-query">
		<AsyncNoSoftwareLicense />
	</ViewExperienceSuccessTracker>
);
